/**
 * canvas の上限（プロバイダ共通）。
 *
 * iOS Safari は面積で制限があり、超えると描画が空になる（NFR-COMPAT-01）。
 * この上限は「1 枚のラスタ」に掛かるものであって、拡大の上限ではない —
 * 可視領域だけを切って要求すれば、同じ上限のまま実効解像度を上げられる（設計書 L361）。
 */
export const MAX_CANVAS_AREA = 5_200_000;
export const MAX_CANVAS_SIDE = 4096;

/**
 * 縦横比 aspect（= 高さ / 幅）のラスタを 1 枚で作れる最大の幅。
 * 面積・一辺の両方の上限を満たす。
 */
export function maxWidthFor(aspect: number): number {
  const byArea = Math.sqrt(MAX_CANVAS_AREA / aspect);
  return Math.max(1, Math.floor(Math.min(byArea, MAX_CANVAS_SIDE, MAX_CANVAS_SIDE / aspect)));
}
